
import { Component, Input, inject } from '@angular/core';
import {
  ControlValueAccessor,
  FormsModule,
  NgControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

import { ErrorStateMatcher } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { ErrorMessagesPipe } from '../pipes/error-messages.pipe';
import { DefaultErrorStateMatcher } from '../validation/DefaultErrorStateMatcher';

@Component({
    selector: 'cerrix-input',
    imports: [
    ErrorMessagesPipe,
    FormsModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule
],
    templateUrl: './cerrix-input.component.html',
    styleUrl: './cerrix-input.component.scss',
    providers: []
})
export class CerrixInputComponent implements ControlValueAccessor {
  @Input() public value: string = '';
  @Input() public placeholder: string = '';
  @Input() public disabled: boolean = false;
  @Input() public suffixIcon: string | null = null;
  @Input() public dataUiid: string = "undefined"

  protected errorMatcher!: ErrorStateMatcher;
  protected ngControl = inject(NgControl, { optional: true, self: true });

  private onValueChange = (value: string) => {};
  private onTouched = () => {};

  public writeValue(value: string): void {
    this.value = value;
  }
  public registerOnChange(onChange: (value: string) => void): void {
    this.onValueChange = onChange;
  }
  public registerOnTouched(onTouched: () => void): void {
    this.onTouched = onTouched;
  }
  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  constructor() {
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
      this.errorMatcher = new DefaultErrorStateMatcher();
    }
  }

  protected onChange(event: Event) {
    this.value = (event.target as HTMLInputElement)?.value;
    this.onValueChange(this.value);
  }
}
